import { NgModule } from '@angular/core';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { CertificationCardComponent } from './certification-card.component';
import { DisplayHtmlModule } from '@certemy/ui-components';

@NgModule({
  declarations: [CertificationCardComponent],
  imports: [CertemyCommonModule, DisplayHtmlModule],
  exports: [CertificationCardComponent],
})
export class CertificationCardModule {}
